import FinancialDashboardGraphic from "../../../../components/financialDashboard/componentes/FinancialDashboardGraphic/FinancialDashboardGraphic";
import { CardDetailsfee } from "../../../../components/financialDashboard/componentes/Card-details/Card-detailsfee";
import { FilterGraphic } from "../../../../components/financialDashboard/componentes/FilterGraphic/FilterGraphic";

import { useTranslation, Trans } from "react-i18next";
import { useEffect, useState } from "react";
import { FinancialDTO } from "../../financial-DTO";
import { SparkIcon } from "@bosch-web-dds/spark-ui-react";
import { getFinancial } from "../../financial-service";
import TableDetailsfee from "../../../../components/financialDashboard/componentes/table-details/table-detailsfee";
import { useAuth } from "../../../../contexts/auth-context";
import stonks from "../../../../assets/img/stonks.svg"
import FinancialDashboardGraphicfee from "../../../../components/financialDashboard/componentes/FinancialDashboardGraphic/financialDashboardGraphic-fee";

const FinancialDashboardAdminfee:React.FC<{ enabledUsers: string[] }> = ({

}) => {
  const { t } = useTranslation();
  const { userDoc, currentUser, loading } = useAuth()
  const [showChart, setShowChart] = useState<Boolean>(true);
  const [idTofilter, setIdTofilter] = useState<string>();
  const [totalDetails, setTotalDetails] = useState<FinancialDTO[] | null>(null);

  useEffect(() => {
    if (!loading && userDoc?.originId && userDoc?.profile) {
      const fetchTotalDetails = async () => {
        try {
          const result = await getFinancial(userDoc?.profile, userDoc?.originId);
          const data = result.map((obj: any) =>
            Number.isNaN(Number(obj.valueFee)) ? { ...obj, valueFee: 0 } : obj
          );
          setTotalDetails(data.filter((obj: any) => obj.valueFee > 0));
        } catch (err) {}
      };
      fetchTotalDetails();
    }
  }, [userDoc]);
  

  if (loading) return null

  return (
    <div>
      {showChart == true ? (
        <div className="flex-column">
          <div className="flex-row justify-between align-center">
            <div className="flex-row align-center ">
              <SparkIcon icName="chart-bar" />
              <h3 style={{ margin: "0" }}>{t("financial-dashboard.titlesfee")}</h3>
            </div>

            <div className="filter">
              <FilterGraphic
                data={totalDetails}
                setIdTofilter={setIdTofilter}
              />
              <div>
                <SparkIcon
                  onClick={() => setShowChart(false)}
                  icName="list-view"
                  noPadding
                />
              </div>
            </div>
          </div>

          {totalDetails && totalDetails?.length > 0 ?
            <div className="flex-row">
              <>
                <div className="card">
                  <CardDetailsfee data={totalDetails} idTofilter={idTofilter || ""} />
                </div>
                <div className="chart">
                  <FinancialDashboardGraphicfee
                    data={totalDetails}
                    idTofilter={idTofilter || ""}
                  />
                </div>
              </>
            </div>
            :
            <div className="empty-slot">
              <img
                style={{ marginBottom: 10, maxHeight: "8rem", fill: "#5a5a5a" }}
                src={stonks}
                alt="no data ilustration"
              />
              <h4>{t('financial-dashboard.no-data')}</h4>
            </div>
          }
        </div>
      ) : (
        <div className="first-financial">
          <div
            className="flex-row justify-between align-center"
            style={{ padding: "10px" }}
          >
            <h3>{t("financial-dashboard.titlesfee")}</h3>
            <div className="filter">
              <div className="margin">
              <FilterGraphic
                data={totalDetails}
                setIdTofilter={setIdTofilter}
              />
              </div>
              <div>
                <SparkIcon
                  onClick={() => setShowChart(true)}
                  icName="chart-bar"
                  
                  noPadding
                  
                />
              </div>
            </div>
          </div>
          {totalDetails && (
            <TableDetailsfee data={totalDetails} idTofilter={idTofilter || ""} />
          )}
        </div>
      )}
    </div>
  );
};

export default FinancialDashboardAdminfee;

